import { useContext } from 'react';
import { ConfigContext } from 'providers/config';

// ==============================|| CONFIG - HOOKS  ||============================== //

const useConfig = () => useContext(ConfigContext);

export default useConfig;
